export default __webpack_public_path__ + "static/media/centroMoons-mobile@2x.7d773854.webp";